export enum GuideTypes {
  CHANGE_RECENT_VIEW = '@recentView/CHANGE_RECENT_VIEW',
  CHANGE_RECENT_PATH = '@recentView/CHANGE_RECENT_PATH',
}

export interface IRecentView {
  recentView: string[]
  recentPath: string
}
